import { useLatestAlertingChangelogEntries } from '@retail/sanity/data-access';
import { useConsumerType, useSanityLanguageCode } from '@retail/sanity/hooks';
import { ChangelogEntriesDialog } from '@retail/changelog/components';
import { useDisclosure } from '@shared/hooks';
import React, { useMemo } from 'react';
import { ChangelogEntry } from '@retail/changelog/types';
import { useAlertedChangelogEntries } from './useAlertedChangelogEntries';
import { useSelectedOrgUnit } from '@retail/app/stores/selected-context';

export const LatestChangeLogEntryPopupContainer: React.FC = () => {
  const newChangelogEntriesDialog = useDisclosure();
  const { addValue, hasValue } = useAlertedChangelogEntries();
  const language = useSanityLanguageCode();
  const consumer = useConsumerType();
  const { appTenant } = useSelectedOrgUnit();

  const { data: changelogEntriesDto = [] } = useLatestAlertingChangelogEntries({
    language,
    consumer,
    country: appTenant.countryCode,
  });

  const alertingChangelogEntries = useMemo(
    () =>
      changelogEntriesDto
        .filter(({ id }) => !hasValue(id))
        .map((dto) => ChangelogEntry.fromDto(dto, false)),
    [changelogEntriesDto, hasValue]
  );

  if (alertingChangelogEntries.length === 0) return null;

  const onCloseDialog = () => {
    alertingChangelogEntries.forEach((entry) => addValue(entry.id));
    newChangelogEntriesDialog.onClose();
  };

  return <ChangelogEntriesDialog entries={alertingChangelogEntries} onClose={onCloseDialog} />;
};
